import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.array.filter";
import "core-js/modules/es.object.to-string";
import { __assign, __awaiter, __decorate, __extends, __generator } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
import { loading, enumData, userPrefPageSize } from '@/decorators';
import AddEditModal from './addEditModal.vue';
import { namespace } from 'vuex-class';
import LogModal from './logModal.vue';
import util from '@/utils/util';
var logModalCom = util.mountVueComponent(LogModal);
var User = namespace('user');

var ConsumableMaterialListPage = function (_super) {
  __extends(ConsumableMaterialListPage, _super);

  function ConsumableMaterialListPage() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.searchData = _this.initSearchData();
    _this.lastParams = {};
    _this.total = 0;
    _this.dataList = [];
    _this.columns = [];
    _this.loadingStatus = false;
    _this.warehouseList = [];
    _this.selectedList = [];
    _this.rowSelection = {};
    _this.datetimeDefaultValue = _this.$util.getDefaultTimeCondition();
    _this.addEditVisible = false;
    _this.rowData = {};
    _this.consumableStatusEnum = [];
    _this.consumableOptionEnum = [{
      value: 'consumable_code',
      text: _this.t('耗材编码')
    }, {
      value: 'consumable_name',
      text: _this.t('耗材名称')
    }];
    _this.consumableTypeEnum = [];
    _this.packageTimeTypeEnum = [{
      value: 'create_time',
      text: _this.t('创建时间')
    }, {
      value: 'update_time',
      text: _this.t('更新时间')
    }];
    _this.searchTimeType = _this.$enum.warehouse.ConsumableMaterialTimeType.UPDATE_TIME;
    return _this;
  }

  ConsumableMaterialListPage.prototype.created = function () {
    this.rowSelection = {
      selectedRowKeys: this.selectedList,
      onChange: this.onSelectChange
    };
    this.setColumns();
    this.queryList();
  };

  ConsumableMaterialListPage.prototype.setColumns = function () {
    this.columns = [{
      title: this.t('耗材类型'),
      dataIndex: 'consumable_type_text',
      filterEmpty: true,
      isCopy: true
    }, {
      title: this.t('耗材编码'),
      dataIndex: 'consumable_code',
      filterEmpty: true,
      isCopy: true
    }, {
      title: this.t('耗材名称'),
      dataIndex: 'consumable_name',
      filterEmpty: true
    }, {
      title: this.t('备注'),
      dataIndex: 'remark',
      filterEmpty: true
    }, {
      title: this.t('状态'),
      dataIndex: 'audit_status_text',
      scopedSlots: {
        customRender: 'audit_status_text'
      }
    }, {
      title: this.t('时间'),
      dataIndex: 'time',
      width: 200,
      scopedSlots: {
        customRender: 'time'
      }
    }, {
      width: 150,
      title: this.t('操作'),
      fixed: 'right',
      name: 'operation',
      scopedSlots: {
        customRender: 'operation'
      }
    }];
  };

  ConsumableMaterialListPage.prototype.initSearchData = function () {
    return {
      audit_status: undefined,
      consumable_option: 'consumable_name',
      consumable_option_value: undefined,
      consumable_code: undefined,
      consumable_name: undefined,
      consumable_type: undefined,
      create_time_start: undefined,
      create_time_end: undefined,
      update_time_start: undefined,
      update_time_end: undefined,
      page_index: 1,
      page_size: 20
    };
  };

  ConsumableMaterialListPage.prototype.onSelectChange = function (selectedRowKeys) {
    this.selectedList = this.rowSelection.selectedRowKeys = selectedRowKeys;
  };

  ConsumableMaterialListPage.prototype.formatSearchData = function (params) {
    var newParams = this.$util.deepCopy(params);
    newParams[newParams.consumable_option] = newParams.consumable_option_value;
    delete newParams.consumable_option;
    delete newParams.consumable_option_value;
    newParams[this.searchTimeType + "_start"] = this.datetimeDefaultValue.length ? this.$util.formatDateTime(this.datetimeDefaultValue[0]) : undefined;
    newParams[this.searchTimeType + "_end"] = this.datetimeDefaultValue.length ? this.$util.formatDateTime(this.datetimeDefaultValue[1]) : undefined;
    return newParams;
  };

  ConsumableMaterialListPage.prototype.queryList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var params, data, list, total;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            params = this.formatSearchData(this.searchData);
            this.lastParams = params;
            this.total = null;
            return [4, this.$api.wrapper.queryConsumableMaterialList(params)];

          case 1:
            data = _a.sent().data;
            list = data.list, total = data.total;
            this.dataList = list || [];
            this.total = total;
            return [2];
        }
      });
    });
  };

  ConsumableMaterialListPage.prototype.handlePageChange = function (val) {
    this.searchData.page_index = val;
    this.selectedList.length = 0;
    this.queryList();
  };

  ConsumableMaterialListPage.prototype.handleTabChange = function (key) {
    this.initPage();
    this.queryList();
  };

  ConsumableMaterialListPage.prototype.initPage = function () {
    this.selectedList.length = 0;
    this.searchData.page_index = 1;
  };

  ConsumableMaterialListPage.prototype.handleSearch = function () {
    this.initPage();
    this.queryList();
  };

  ConsumableMaterialListPage.prototype.handleReset = function () {
    var _this = this;

    this.searchData = this.initSearchData();
    this.datetimeDefaultValue = this.$util.getDefaultTimeCondition();
    this.$nextTick(function () {
      return _this.queryList();
    });
  };

  ConsumableMaterialListPage.prototype.handleExport = function (isAll) {
    return __awaiter(this, void 0, Promise, function () {
      var postData, _a, code, data, message;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            postData = {};

            if (isAll) {
              postData = __assign({}, this.lastParams);
              delete postData.page_index;
              delete postData.page_size;
            } else {
              if (!this.selectedList.length) {
                return [2, this.$message.warn(this.t('common', this.$config.exportSelectedEmptyTip))];
              }

              postData.consumable_code_list = this.selectedList;
            }

            return [4, this.$api.wrapper.exportConsumableMaterial(postData)];

          case 1:
            _a = _b.sent(), code = _a.code, data = _a.data, message = _a.message;

            if (code === 0) {
              this.$util.exportExcel(data);
            } else {
              this.$message.error(message);
            }

            return [2];
        }
      });
    });
  };

  ConsumableMaterialListPage.prototype.handleAdd = function () {
    this.rowData.title = this.t('新增耗材');
    this.rowData.warehouseList = this.warehouseList.filter(function (item) {
      return item.is_used;
    });
    this.rowData.data = null;
    this.addEditVisible = true;
  };

  ConsumableMaterialListPage.prototype.handleEdit = function (record) {
    this.rowData.title = this.t('编辑耗材');
    this.rowData.warehouseList = this.warehouseList.filter(function (item) {
      return item.is_used;
    });
    this.rowData.data = record;
    this.addEditVisible = true;
  };

  ConsumableMaterialListPage.prototype.handleCancel = function (consumableCode) {
    var _this = this;

    var modal = this.$confirm({
      title: this.t('废弃提示'),
      content: this.t('请确认是否废弃该记录？'),
      onOk: function onOk() {
        return __awaiter(_this, void 0, Promise, function () {
          var _a, code, message, error_1;

          return __generator(this, function (_b) {
            switch (_b.label) {
              case 0:
                _b.trys.push([0, 2,, 3]);

                return [4, this.$api.wrapper.discardConsumableMaterial({
                  consumable_code: consumableCode
                })];

              case 1:
                _a = _b.sent(), code = _a.code, message = _a.message;

                if (code === 0) {
                  this.$message.success(this.t('操作成功'));
                  this.queryList();
                  this.selectedList.length = 0;
                } else {
                  this.$message.error(message);
                }

                return [3, 3];

              case 2:
                error_1 = _b.sent();
                modal.destroy();
                return [3, 3];

              case 3:
                return [2];
            }
          });
        });
      }
    });
  };

  ConsumableMaterialListPage.prototype.handleLog = function (record) {
    logModalCom({
      parent: this,
      propsData: {
        consumable_code: record.consumable_code
      }
    });
  };

  __decorate([enumData('ConsumableStatusEnum')], ConsumableMaterialListPage.prototype, "consumableStatusEnum", void 0);

  __decorate([enumData('ConsumableTypeEnum')], ConsumableMaterialListPage.prototype, "consumableTypeEnum", void 0);

  __decorate([User.State('customerInfo')], ConsumableMaterialListPage.prototype, "customerInfo", void 0);

  __decorate([userPrefPageSize('wrapperList')], ConsumableMaterialListPage.prototype, "initSearchData", null);

  __decorate([loading('loadingStatus')], ConsumableMaterialListPage.prototype, "queryList", null);

  ConsumableMaterialListPage = __decorate([Component({
    components: {
      AddEditModal: AddEditModal
    }
  })], ConsumableMaterialListPage);
  return ConsumableMaterialListPage;
}(Vue);

export default ConsumableMaterialListPage;